import styled from 'styled-components';
import InputMask from 'react-input-mask';

export const DivInputContainer = styled.div<{
  error: boolean;
  bottom?: string;
}>`
  flex-direction: column;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.18);
  border-radius: 16px;
  align-items: center;
  height: 72px;
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '28px')};
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};
`;

export const Input = styled(InputMask)`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.gray};
  text-align: center;
  border: none;
  border-radius: 16px;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 140%;

  ::placeholder {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 140%;
    opacity: 0.2;
  }
`;

export const TagError = styled.div`
  position: relative;
  z-index: 20;
  padding: 2px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: 16px;
  bottom: 10px;
  margin: 0 auto;
`;
